// TinyMCEEditor.js
import React from 'react';
import { Editor } from '@tinymce/tinymce-react';

const TinyMCEEditor = ({ value, onChange }) => {
  const handleEditorChange = (content, editor) => {
    onChange(content);
  };

  return (
    <Editor
      apiKey="1kqd74m2v2snqjq1q3zh424movvvt9rev6zr67pzhs2rg369"
      value={value}
      onEditorChange={handleEditorChange}
      init={{
        height: 500,
        menubar: true,
        plugins:
          "advlist autolink lists link image charmap preview anchor " +
          "searchreplace visualblocks code fullscreen " +
          "insertdatetime media table code help wordcount"+
          "image",
        toolbar:
          "undo redo | formatselect  " +
          "bold italic backcolor  alignleft aligncenter " +
          "alignright alignjustify  bullist numlist outdent indent  " +
          "removeformat image help" ,
          // "image",
        content_style:
          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        image_advtab: true,
        file_picker_types: "image", // Allow image uploads
        file_picker_callback: function (callback, value, meta) {
          // Open a file picker dialog
          const input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");
  
          // Handle file selection
          input.onchange = function () {
            const file = input.files[0];
            const reader = new FileReader();
  
            // Read the file as a data URL
            reader.onload = function () {
              const dataUrl = reader.result;
  
              // Pass the selected image URL to the editor
              callback(dataUrl, { alt: file.name });
            };
  
            reader.readAsDataURL(file);
          };
  
          input.click();
        },
      }}
    />
  );
};

export default TinyMCEEditor;
